export const MARKETING_PAGE_TOP_BAR_Z_INDEX = 100;
export const SNACKBAR_Z_INDEX = 9999999999;
